/**
 * Where the guided Bedtime page keeps story details typed and not yet saved (E1). Kept apart from
 * the draft module so signing out can clear every draft without loading the page's code.
 */
export const GUIDED_STORY_DRAFT_PREFIX = "lifescapsule:guided-bedtime-draft:v1:";

/**
 * Signing out lets every kept draft go (review P2-27): on a shared device, a child's name never
 * waits in this browser for the next person. Storage that can't be read has nothing to clear.
 */
export function clearGuidedStoryDrafts() {
  try {
    const store = window.localStorage;
    const keys: string[] = [];
    for (let index = 0; index < store.length; index += 1) {
      const key = store.key(index);
      if (key?.startsWith(GUIDED_STORY_DRAFT_PREFIX)) keys.push(key);
    }
    for (const key of keys) store.removeItem(key);
  } catch {
    // Blocked storage keeps nothing to clear.
  }
}
